import React from 'react';

export const OneDriveIconBorderless = () => (
	<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.86388 3.20227L6.86406 3.20165L10.6427 5.46503L12.8944 4.51749C13.3519 4.31969 13.8453 4.21826 14.3438 4.21875C14.4268 4.21875 14.5089 4.22252 14.5906 4.22797C14.3199 3.17239 13.7484 2.21816 12.9456 1.48125C12.1428 0.744328 11.1432 0.256448 10.0684 0.0768914C8.99354 -0.102665 7.88968 0.0338335 6.89095 0.469799C5.89222 0.905765 5.04162 1.62243 4.4425 2.5327C4.46175 2.53246 4.48071 2.53125 4.5 2.53125C5.33512 2.53012 6.15391 2.76254 6.86388 3.20227Z"
			fill="#0364B8"
		/>
		<path
			d="M6.86405 3.20165L6.86388 3.20227C6.15391 2.76255 5.33511 2.53012 4.5 2.53125C4.48071 2.53125 4.46172 2.53246 4.4425 2.53271C3.62513 2.54282 2.82597 2.77548 2.1309 3.20568C1.43582 3.63587 0.871116 4.24734 0.497459 4.97437C0.123801 5.7014 -0.0446795 6.51651 0.0101211 7.3321C0.0649218 8.14769 0.340932 8.93293 0.808492 9.60344L4.14074 8.20117L5.62204 7.57781L8.92028 6.18987L10.6427 5.46503L6.86405 3.20165Z"
			fill="#0078D4"
		/>
		<path
			d="M14.5905 4.22797C14.5089 4.22252 14.4268 4.21875 14.3437 4.21875C13.8453 4.21827 13.352 4.32007 12.8944 4.51788L10.6427 5.46503L11.2956 5.85613L13.4359 7.13813L14.3697 7.69747L17.5626 9.61C17.8528 9.07142 18.0031 8.46864 17.9999 7.85689C17.9967 7.24515 17.8401 6.64398 17.5444 6.10845C17.2486 5.57292 16.8232 5.12016 16.3072 4.79162C15.7911 4.46309 15.2009 4.26928 14.5905 4.22797Z"
			fill="#1490DF"
		/>
		<path
			d="M14.3697 7.69745L13.4359 7.13812L11.2956 5.85612L10.6427 5.46503L8.92026 6.18985L5.62202 7.5778L4.14072 8.20116L0.808472 9.60342C1.22256 10.1988 1.77459 10.6851 2.41742 11.0208C3.06024 11.3565 3.77477 11.5316 4.49997 11.5312H14.3437C15.0037 11.5314 15.6515 11.3529 16.2182 11.0147C16.785 10.6764 17.2495 10.191 17.5626 9.60999L14.3697 7.69745Z"
			fill="#28A8EA"
		/>
	</svg>
);
